import React from "react";
import "./Services.css";

export default function Services() {
  return (
    <div className="services-page">
      <div className="services-header">
        <h1>Our Services</h1>
        <p>Explore how Agent Samur.ai can transform your business</p>
      </div>

      <div className="services-container">
        <div className="service-card">
          <div className="service-icon">🤖</div>
          <h3>AI Strategy Consulting</h3>
          <p>
            We provide strategic guidance on how to effectively implement AI in
            your business processes, ensuring alignment with your overall
            business objectives.
          </p>
          {/* <a href="/services/consulting" className="service-btn">
            Learn More
          </a> */}
        </div>

        <div className="service-card">
          <div className="service-icon">⚙️</div>
          <h3>Process Automation</h3>
          <p>
            Streamline your operations with our intelligent automation
            solutions. Reduce manual work and increase efficiency across your
            organization.
          </p>
          {/* <a href="/services/automation" className="service-btn">
            Learn More
          </a> */}
        </div>

        <div className="service-card">
          <div className="service-icon">📊</div>
          <h3>Data Analysis</h3>
          <p>
            Extract actionable insights from your data. Our advanced analytics
            tools help you make better business decisions based on concrete
            information.
          </p>
          {/* <a href="/services/analysis" className="service-btn">
            Learn More
          </a> */}
        </div>

        <div className="service-card">
          <div className="service-icon">🔍</div>
          <h3>Custom AI Development</h3>
          <p>
            Tailored AI solutions built specifically for your unique business
            challenges. Our expert team creates models that address your exact
            needs.
          </p>
          {/* <a href="/services/development" className="service-btn">
            Learn More
          </a> */}
        </div>

        <div className="service-card">
          <div className="service-icon">🏢</div>
          <h3>Enterprise Implementation</h3>
          <p>
            Full-scale AI integration for large organizations. We handle
            everything from planning to deployment and ongoing support.
          </p>
          {/* <a href="/services/enterprise" className="service-btn">
            Learn More
          </a> */}
        </div>

        <div className="service-card">
          <div className="service-icon">🎓</div>
          <h3>AI Training & Workshops</h3>
          <p>
            Educate your team on AI capabilities and best practices. Our
            workshops are designed to build AI literacy across your
            organization.
          </p>
          {/* <a href="/services/training" className="service-btn">
            Learn More
          </a> */}
        </div>
      </div>
    </div>
  );
}

// import React from "react";
// import "./Services.css";

// export default function Services() {
//   return (
//     <div className="services-page">
//       <div className="services-header">
//         <h1>Our Services</h1>
//         <p>Explore how Agent Samur.ai can transform your business</p>
//       </div>

//       <div className="services-container">
//         <div className="service-card">
//           {/* Replace emoji with image */}
//           <div className="service-image">
//             <img src="/images/ai-strategy.jpg" alt="AI Strategy Consulting" />
//           </div>
//           <h3>AI Strategy Consulting</h3>
//           <p>
//             We provide strategic guidance on how to effectively implement AI in
//             your business processes, ensuring alignment with your overall
//             business objectives.
//           </p>
//           {/* <a href="/services/consulting" className="service-btn">
//             Learn More
//           </a> */}
//         </div>

//         <div className="service-card">
//           {/* Replace emoji with image */}
//           <div className="service-image">
//             <img src="/images/automation.jpg" alt="Process Automation" />
//           </div>
//           <h3>Process Automation</h3>
//           <p>
//             Streamline your operations with our intelligent automation
//             solutions. Reduce manual work and increase efficiency across your
//             organization.
//           </p>
//           {/* <a href="/services/automation" className="service-btn">
//             Learn More
//           </a> */}
//         </div>

//         <div className="service-card">
//           {/* Replace emoji with image */}
//           <div className="service-image">
//             <img src="/images/data-analysis.jpg" alt="Data Analysis" />
//           </div>
//           <h3>Data Analysis</h3>
//           <p>
//             Extract actionable insights from your data. Our advanced analytics
//             tools help you make better business decisions based on concrete
//             information.
//           </p>
//           {/* <a href="/services/analysis" className="service-btn">
//             Learn More
//           </a> */}
//         </div>

//         <div className="service-card">
//           {/* Replace emoji with image */}
//           <div className="service-image">
//             <img src="/images/custom-ai.jpg" alt="Custom AI Development" />
//           </div>
//           <h3>Custom AI Development</h3>
//           <p>
//             Tailored AI solutions built specifically for your unique business
//             challenges. Our expert team creates models that address your exact
//             needs.
//           </p>
//           {/* <a href="/services/development" className="service-btn">
//             Learn More
//           </a> */}
//         </div>

//         <div className="service-card">
//           {/* Replace emoji with image */}
//           <div className="service-image">
//             <img src="/images/enterprise.jpg" alt="Enterprise Implementation" />
//           </div>
//           <h3>Enterprise Implementation</h3>
//           <p>
//             Full-scale AI integration for large organizations. We handle
//             everything from planning to deployment and ongoing support.
//           </p>
//           {/* <a href="/services/enterprise" className="service-btn">
//             Learn More
//           </a> */}
//         </div>

//         <div className="service-card">
//           {/* Replace emoji with image */}
//           <div className="service-image">
//             <img src="/images/training.jpg" alt="AI Training & Workshops" />
//           </div>
//           <h3>AI Training & Workshops</h3>
//           <p>
//             Educate your team on AI capabilities and best practices. Our
//             workshops are designed to build AI literacy across your
//             organization.
//           </p>
//           {/* <a href="/services/training" className="service-btn">
//             Learn More
//           </a> */}
//         </div>
//       </div>
//     </div>
//   );
// }
